<!-- eslint-disable -->
<script setup>

import { ref, onMounted, computed, onBeforeMount} from 'vue';
import { useRouter } from 'vue-router';
import { closeModal, confirmModal } from '@kolirt/vue-modal'
import { useLanguagesStore } from '../../stores/languages';
import { useCurrenciesStore } from '../../stores/currencies';
import { useCountriesStore } from '../../stores/countries';
import { useRegisterStore } from '../../stores/register';
import { useCustomerStore } from '../../stores/customer';
import { useGeneralStore } from '@/stores/general';
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useReferralStore } from '@/stores/referral';
import { useBonusStore } from "@/stores/bonus";
import { usePaymentGatewaysStore } from "@/stores/payment_gateways";
import { useInitializeStore } from '@/stores/initialize';

const svg_data = commonSvgs;
const { t } = useI18n();
const router = useRouter();
const customerStore = useCustomerStore();
const languagesStore = useLanguagesStore();
const countriesStore = useCountriesStore();
const currenciesStore = useCurrenciesStore();
const registerStore = useRegisterStore();
const initializeStore = useInitializeStore();
const generalStore = useGeneralStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const referralStore = useReferralStore();
const paymentGatewayStore = usePaymentGatewaysStore();
const bonusStore = useBonusStore();

const current_step = ref(1);
const password_visibility = ref(false);
const step_count = ref(1);
const registration_completed = ref(false);
const loading = ref(false);
const is_chat_enabled = ref(null);
const is_verification_enabled = ref(true)
const use_gradient = ref(true);
const is_country_ghana = process.env.VUE_APP_COUNTRY == 'GHANA';
const was_number_verified = ref(false);

const taboolaEventName = computed(() =>
	is_country_ghana ? "Betboroghana_registration" : "Betegram_registration"
);

onMounted(() => {
	initializeStore.fireTaboolaEventOnce(taboolaEventName.value);
});

const incrementCurrenctStep = () => {
	let validated = registerStore.validateStep(current_step.value)
	if (current_step.value == registerStore.getAllSteps ) {
		submitRegister()
	} else if (validated) {
		const enabled_fields = getStepFields();
		const hasUsernameOrEmail = enabled_fields.some(
			field => field.slug === 'email' || field.slug === 'username'
		);

		// if (hasUsernameOrEmail) {
		// 	let payload = {};

		// 	for (const field of enabled_fields) {
		// 		if (field.slug === 'email' || field.slug === 'username') {
		// 			payload[field.slug] = registerStore.register_input_fields[field.slug];
		// 		}
		// 	}

		// 	registerStore.checkRegister(payload).then(() => {
		// 			current_step.value++;
		// 		}).catch(error => {
		// 			console.log(error)
		// 		});

		// 	return;
		// }


		current_step.value++;
	}
}

const decrementCurrentStep = () => {
	current_step.value--;
}

const changeStep = (step) => {
	let validated;
	// Check if the step is greater than the current step, if validation passes, increment the current step
	if (current_step.value < step) {
		validated = registerStore.validateStep(current_step.value);
		// If validation passes, increment the current step
		if (validated) current_step.value++;
		// If the step is not greater and the current step decrement the current step
	} else if (current_step.value > 1) {
		current_step.value--;
	}
}

function getCookieValue(name) {
	let cookie_array = document.cookie.split(';');
	for (let i = 0; i < cookie_array.length; i++) {
		let cookie_pair = cookie_array[i].split('=');
		if (name == cookie_pair[0].trim()) {
			return decodeURIComponent(cookie_pair[1]);
		}
	}

	return null;
}

const submitRegister = () => {
	const enabled_fields = registerStore.getEnabledRegistrationFields;
	let payload = {};

	if (registerStore.register_input_fields.number_verification) {
		was_number_verified.value = true;
	}

	if (is_country_ghana) {
		if (!registerStore.register_input_fields.username) {
			let mobile_number = registerStore.register_input_fields.mobile_number;

			// If first digit is 0, remove it
			if (mobile_number.startsWith('0')) {
				mobile_number = mobile_number.substring(1);
			}

			payload['username'] = mobile_number;
		}
	}

	for (const field of enabled_fields) {
		if (registerStore.register_input_fields[field.slug]) {
			payload[field.slug] = registerStore.register_input_fields[field.slug];
		}
	}

	if (registerStore.register_input_fields.mobile_country_id) {
		payload['mobile_country_id'] = registerStore.register_input_fields.mobile_country_id;
	}

	const dob = _.find(enabled_fields, { slug: 'dob' });

	if (dob){
		payload['dob_day'] = registerStore.register_input_fields.dob_day;
		payload['dob_month'] = registerStore.register_input_fields.dob_month;
		payload['dob_year'] = registerStore.register_input_fields.dob_year;
	}

	payload['password_confirmation'] = registerStore.register_input_fields.password_confirmation;
	payload['utc_offset'] = registerStore.register_input_fields.utc_offset;
	payload['browser_timezone'] = registerStore.register_input_fields.browser_timezone;


	// Set affiliate cookies
	if (getCookieValue('af_btag') !== null) payload['btag'] = getCookieValue('af_btag');
	if (getCookieValue('af_link') !== null) payload['link'] = getCookieValue('af_link');
	if (getCookieValue('af_banner') !== null) payload['banner'] = getCookieValue('af_banner');

	// Use refer a friend code from component or cookie
	const inputReferralCode = registerStore.register_input_fields.refer_friend_code;
	const cookieReferralCode = getCookieValue('referral_code');

	if (inputReferralCode && inputReferralCode.trim() !== '') {
		// If input has value, use input and set method to 'code'
		payload['refer_a_friend_code'] = inputReferralCode.trim();
		payload['referral_method'] = 'code';
	} else if (cookieReferralCode !== null && cookieReferralCode !== '') {
		// If no input but cookie exists, use cookie and set method to 'link'
		payload['refer_a_friend_code'] = cookieReferralCode;
		payload['referral_method'] = 'link';
	}

	loading.value = true;

	registerStore.submitRegister(payload).then((response) => {
		if (customerStore.auth_token) {
			global.axios.defaults.headers['Authorization'] = 'Bearer ' + customerStore.auth_token;
			customerStore.fetchCustomer();
			customerStore.fetchProtectionConfiguration();

			paymentGatewayStore.fetchCustomerPaymentGateways();
			bonusStore.fetchOffers();
		}

		// Clear referral cookie after successful registration
		referralStore.clearReferralCookie();

		loading.value = false;
		current_step.value++;

		registration_completed.value = true;

		// Fire ATHENA pixel sign_up event
		if (window.aPixel) window.aPixel.tag("sign_up");

		registerStore.initializeForm();
	}).catch(error => {
		if (error && error.data && error.data.errors) {
				current_step.value = registerStore.getFieldStep(Object.keys(error.data.errors)[0]);
				loading.value = false
				return error.data.message;
		}	else {
				loading.value = false;
			}
	});
}

const checkLanguageAndCloseModal = () => {
	if (useLanguagesStore().selected_language.id != customerStore.getCustomer.language.id) {
		window.location.reload();
	} else {
		closeModal();
	}
}

const number_verified = ref(false);
const isRegisterButtonDisabled = computed(() => {
	if (registerStore.hasNumberVerification == true && current_step.value == registerStore.getAllSteps) {
		if (number_verified.value == false) {
			return true;
		} else {
			return false;
		}
	}

	return false;
});

const callNow = () => {
	if (!is_chat_enabled) return;
	window.location.href = 	`tel:${process.env.VUE_APP_CALL_NOW_NUMBER}`;
};

const getStepFields = () => {
	return _.filter(registerStore.enabled_registration_fields, {step: String(current_step.value)})
}

const closeModalAndRedirect = () => {
	closeModal();
	router.push({ name: 'bank-deposits' });
}

onBeforeMount(() => {
	is_chat_enabled.value = platformConfigurationStore.isShowCallBubbleEnabled;
	use_gradient.value = platformConfigurationStore.isGradientColorOnLoginRegisterEnabled;
	if (!platformConfigurationStore.isCustomerVerificationEnabled) is_verification_enabled.value = false;
	if (!platformConfigurationStore.isEmailVerificationEnabled) is_verification_enabled.value = false;
})
</script>
<template>
	<section class="register-panel">
		<div class="container-full">
			<div class="register-panel-main">
				<span class="form-cross" >
					<a @click="closeModal" style="cursor: pointer;">
						<object v-html="svg_data.form_cross"></object>
					</a>
					</span>
					<div class="register-panel-left">
				<div class="register-image-box" :class="{ 'no-gradient': !use_gradient }">

					<div class="register-logo">
						<div class=""></div>
						<img :src="generalStore.getGeneral.header_logo" alt="register-logo" @click="closeModal">
					</div>

					<div class="register-bg-image">
						<img :src="generalStore.getGeneral.register_background" alt="register-bg"/>
					</div>

				</div>
			</div>

				<div class="register-panel-right">

					<div v-if="!registration_completed" id="multi-step-form-container" class="register-form-main">
						<h2>{{ $t('account.register.create_account') }}</h2>
						<!-- Form Steps / Progress Bar -->
						<ul class="form-register form-register-horizontal">
							<!-- Step 1 -->
							<li class=" form-register-list"  v-for="step_count in registerStore.getAllSteps" :key="step_count" :class="current_step  == step_count ? 'form-register-active' : 'form-register-unfinished'" @click="changeStep(step_count)" style="cursor: pointer;" :step="step_count">
								<a class="">
									<span class="form-register-circle text-muted">
										<span>{{step_count}}</span>
									</span>
								</a>
							</li>
						</ul>
						<!-- Step Wise Form Content -->
						<form class="register-outer-form" id="userAccountSetupForm" name="userAccountSetupForm"
							enctype="multipart/form-data" method="POST">
							<section v-for="step_count in registerStore.getAllSteps" :key="step_count" class="form-step">
									<template v-if="current_step == step_count">
										<div class="close_btn" style="cursor: pointer;">
											<a href="#" @click="closeModal" class="form-mobile-back-close">
												<object v-html="svg_data.form_cross"></object>
											</a>
										</div>

										<div class="register-inner-form">

										<template v-for="field in registerStore.getStepFieldComponents(step_count)" :key="field">
											<component :is="field"></component>
										</template>
										</div>

										<div v-if="step_count > 1" class="form-btns">
												<button @click="decrementCurrentStep" class="btn btn-navigate-form-step btn-form-prev" type="button"
													step_number="1">{{ $t('general.back') }}</button>
												<button v-if="!loading" @click="incrementCurrenctStep()" class="btn btn-secondary btn-navigate-form-step" type="button">
													{{ (current_step == registerStore.getAllSteps) ? $t('account.register.create_account') : $t('general.next') }}&nbsp;</button>
												<button v-else class="btn btn-secondary btn-navigate-form-step" type="button"><div class="loader-main"></div></button>
										</div>
										<div v-else class="form-btn-single">
												<button @click="incrementCurrenctStep()" class="btn btn-secondary btn-navigate-form-step" type="button">
													{{ (current_step == registerStore.getAllSteps) ? $t('account.register.create_account') : $t('general.next') }}&nbsp;
												</button>
										</div>
									</template>
								</section>
							</form>
						</div>

						<section v-if="registration_completed" id="step-4" class="form-step">
							<!-- Step 4 input fields -->
							<div class="register-form-main" style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 15px; margin-bottom: 30px;">
								<h2 v-if="registerStore.hasEmail && is_verification_enabled && !was_number_verified" style="margin: 0;">{{ $t('account.register.thank_you_for_your_registration') }}</h2>
								<h2 v-else style="margin: 0;">{{ $t('account.register.thank_you_for_your_registration_no_email_field') }}</h2>

								<p v-if="is_country_ghana && platformConfigurationStore.isGhanaSmsVerificationEnabled && !was_number_verified" style="color: var(--white); font-size: 0.95rem; margin: 0;">
									{{ $t('account.register.verification_reminder') }}
								</p>
								<p v-else-if="is_country_ghana && platformConfigurationStore.isGhanaSmsVerificationEnabled && was_number_verified" style="color: var(--white); font-size: 0.95rem; margin: 0;">
									{{ $t('account.register.verification_success_text') }}
								</p>
							</div>

							<div class="form-btns">
								<button @click="closeModalAndRedirect()" class="btn btn-secondary btn-navigate-form-step" type="button" style="cursor: pointer; width: auto; padding: 8px 30px; font-size: 14px;">{{ $t('bank.deposit.deposit') }}</button>
								<button @click="closeModal()" class="btn btn-navigate-form-step btn-form-prev" type="button" style="cursor: pointer; width: auto; padding: 8px 30px; font-size: 14px;">{{ $t('account.register.close') }}</button>
							</div>
						</section>

						<div v-if="!registration_completed" class="login-option">

							<div v-if="is_chat_enabled" class="help-container">
								<img src="@/assets/images/help-need.webp" @click="callNow()">
								<div class="text-container" @click="callNow()">
									<p>{{ $t('account.register.need_help') }}</p>
									<p>{{ $t('account.register.call_us') }}</p>
								</div>
							</div>

							<p style="margin-top: 14px;">{{ $t('account.register.already_registered') }} <a @click="confirmModal( {show_login: true} )" style="cursor: pointer;">{{ $t('account.login.login') }}</a></p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</template>

<style scoped>
.register-panel .register-panel-main .register-panel-left .register-image-box.no-gradient:before {
	background: none;
}

@media screen and (min-width: 1041px) and (max-width: 3000px){
	.register-panel-right .login-option {
		text-align: center;
	}
}
.form-btns {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}
html[dir="rtl"] .register-panel .register-panel-main .form-cross {
	right: unset;
	left: 30px;
}
html[dir="rtl"] .register-form-main .form-mobile-back {
	left: unset;
	right: 20px;
	transform: rotate(180deg);
}

.disabled-button {
	background: transparent;
	pointer-events: none;
	border: 1px solid var(--tab-gray);
	color: var(--tab-gray);
}

.register-form-main .form-mobile-back-close {
	position: absolute;
	top: 22px;
	right: 20px;
	display: none;
	z-index: 10;
}

html[dir="rtl"] .register-form-main .form-mobile-back-close {
	right: unset;
	left: 20px;
}

@media screen and (max-width: 767px) {
	.register-form-main .form-mobile-back-close {
		display: block;
	}
}

.register-panel .register-panel-main .register-panel-left .register-image-box .register-logo {
	align-items: center;
}

.help-container {
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 2%;
	cursor: pointer;
}

.help-container .text-container p {
	font-size: 12px;
	line-height: 1;
	color: var(--white);
}
</style>